var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SearchOutlined } from "@mui/icons-material";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import { Button, Card, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Form } from "@unform/web";
import React, { useRef } from "react";
import { useHistory } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import { getDebitos } from "../../apis/api";
import Loader from "../../components/Loading";
import { VTextField } from "../../forms/VTextField";
import { Colors } from "../../util/theme";
import ReCAPTCHA from "react-google-recaptcha";
import { useWebgate } from "@xvia/webgate-connect";
var ConsultarIpva = function () {
    var _a = React.useState(false), open = _a[0], setOpen = _a[1];
    var recaptchaRef = React.useRef(null);
    var _b = React.useState(false), isVerified = _b[0], setIsVerified = _b[1];
    var accessToken = useWebgate().accessToken;
    var history = useHistory();
    var formRef = useRef(null);
    var handleClose = function () {
        setOpen(false);
    };
    var handleOpen = function () {
        setOpen(true);
    };
    function handleChange(value) {
        if (value) {
            setIsVerified(true);
        }
        else {
            setIsVerified(false);
        }
    }
    function handleSubmit(data) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var schema, err_1, errorMessages_1, response, obj, errosStr, errosObj, errosArray, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!isVerified) return [3 /*break*/, 1];
                        alert("Por favor, verifique que você não é um robô!");
                        return [3 /*break*/, 10];
                    case 1:
                        setTimeout(function () {
                            if (recaptchaRef.current) {
                                recaptchaRef.current.reset();
                                setIsVerified(false);
                            }
                        }, 5000);
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        schema = Yup.object().shape({
                            placa: Yup.string()
                                .required("A placa e obrigatoria")
                                .matches(/^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$|^[A-Z]{3}\d{1}[A-Z]{1}\d{1}[A-Z0-9]{2}$/i, "Placa inválida"),
                            renavam: Yup.string().required("O Renavam é obrigatório"),
                        });
                        return [4 /*yield*/, schema.validate(data, {
                                abortEarly: false,
                            })];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _b.sent();
                        if (err_1 instanceof Yup.ValidationError) {
                            errorMessages_1 = {};
                            err_1.inner.forEach(function (error) {
                                var _a;
                                var path = (_a = error.path) !== null && _a !== void 0 ? _a : "unknown";
                                errorMessages_1[path] = error.message;
                            });
                            (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.setErrors(errorMessages_1);
                        }
                        return [2 /*return*/];
                    case 5:
                        handleOpen();
                        if (!accessToken) {
                            toast.error("Token de autenticação não encontrado");
                            handleClose();
                            return [2 /*return*/];
                        }
                        response = void 0;
                        _b.label = 6;
                    case 6:
                        _b.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, getDebitos(data, accessToken)];
                    case 7:
                        response = _b.sent();
                        if (response.data.status === "FALHA") {
                            obj = JSON.parse(JSON.stringify(response.data));
                            errosStr = obj.data.erros;
                            errosObj = JSON.parse(errosStr);
                            errosArray = errosObj.erros;
                            errosArray.map(function (item) {
                                return toast.warn(item);
                            });
                        }
                        else {
                            history.push({
                                pathname: "/dar-ipva/debitos",
                                state: response.data,
                            });
                        }
                        return [3 /*break*/, 9];
                    case 8:
                        error_1 = _b.sent();
                        toast.error(String(error_1) || "Algo deu errado");
                        return [3 /*break*/, 9];
                    case 9:
                        handleClose();
                        _b.label = 10;
                    case 10: return [2 /*return*/];
                }
            });
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx(ToastContainer, {}), _jsx(Loader, { open: open, sx: { color: "#fff" }, zIndex: 999 }), _jsx(Box, __assign({ justifyContent: "center", alignItems: "center" }, { children: _jsx(Typography, __assign({ variant: "subtitle1", align: "center" }, { children: _jsx(Card, __assign({ sx: {
                            py: 2,
                            px: { xs: 2, md: 6 },
                        } }, { children: _jsxs(Grid, __assign({ container: true, justifyContent: "center", alignItems: "center", className: "teste" }, { children: [_jsxs(Grid, __assign({ item: true, xs: 12 }, { children: [_jsxs(Typography, __assign({ align: "center", fontWeight: "bold", variant: "h5", gutterBottom: true, display: "flex", alignItems: "center", justifyContent: "center" }, { children: [_jsx(DirectionsCarIcon, { style: { marginRight: "10px" } }), "Consultar IPVA"] })), _jsx("hr", {})] })), _jsx(Box, { children: _jsx(Form, __assign({ ref: formRef, onSubmit: handleSubmit }, { children: _jsxs(Grid, __assign({ container: true, rowSpacing: 4, marginTop: 1, alignItems: "center", justifyContent: "center", maxWidth: "100%" }, { children: [_jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(VTextField, { name: "placa", fullWidth: true, label: "Placa", variant: "outlined", inputProps: { maxLength: 7 } }) })), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(VTextField, { name: "renavam", fullWidth: true, label: "Renavam", variant: "outlined", type: "number", inputProps: { maxLength: 9 } }) })), _jsxs(Grid, __assign({ item: true, xs: 12 }, { children: [_jsx(Typography, { children: "Resolva o problema abaixo:" }), _jsx(ReCAPTCHA, { ref: recaptchaRef, sitekey: "6LfrEosnAAAAAHXo6wURdNdmvRDydWtQ4HfpBEip", onChange: handleChange })] })), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(Button, __assign({ type: "submit", variant: "outlined", startIcon: _jsx(SearchOutlined, {}), sx: {
                                                            color: "#FFF",
                                                            backgroundColor: Colors.AZUL_GOV,
                                                            opacity: 1,
                                                            "&:hover": {
                                                                backgroundColor: Colors.AZUL_GOV,
                                                                opacity: 0.8,
                                                            },
                                                        } }, { children: "Consultar" })) }))] })) })) })] })) })) })) }))] }));
};
export default ConsultarIpva;
